var _excluded = ["icon", "image", "title", "text", "link"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
import { cover } from "polished";
import styled, { css } from "styled-components";
import OnColorContext from "../../../contexts/OnColorContext";
var ArrowSvg = function ArrowSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M0 4a1 1 0 0 1 1-1h20v2H1a1 1 0 0 1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.752 3.168a1 1 0 0 1 0 1.664l-3.197 2.13A1 1 0 0 1 21 6.131V1.87a1 1 0 0 1 1.555-.832l3.197 2.13z"
  }));
};
ArrowSvg.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "27",
  height: "8"
};
import breakpoint from "../../../utils/breakpoint";
import getBorderRadius from "../../../utils/getBorderRadius";
import getBoxShadow from "../../../utils/getBoxShadow";
import getColor from "../../../utils/getColor";
import space from "../../../utils/space";
import transition from "../../../utils/transition";
import IconAtm from "../../atoms/IconAtm";
import { cssTextAtm } from "../../atoms/TextAtm/TextAtm.styled";
import Link from "../../quarks/Link";
import Picture from "../../quarks/Picture";
var iconWrapperSizeSpace = 6;
var descriptionBreakpoint = "medium";
var backgroundColor = "backgroundLight";
var imageWrapperBackgroundColor = "secondary";
var Arrow = styled(ArrowSvg).withConfig({
  componentId: "sc-ivd45s-0"
})(function (_ref) {
  var theme = _ref.theme;
  return css(["", ";fill:", ";"], transition("transform"), getColor(theme, "primary"));
});

/**
 * 1. display: flex is applied from "medium" breakpoint up so as components placed next to each other would have the same height despite the length of the texts
 * */
var Container = styled.div.withConfig({
  componentId: "sc-ivd45s-1"
})(["", "{display:flex;}"], breakpoint("medium"));
var Box = styled.div.withConfig({
  componentId: "sc-ivd45s-2"
})(function (_ref2) {
  var theme = _ref2.theme;
  return css(["", ";display:flex;position:relative;flex:1;align-items:center;justify-content:space-between;padding:", " ", ";border-radius:", ";background-color:", ";box-shadow:", ";&:hover{box-shadow:", ";", "{transform:translateX(", ");}}", "{flex-direction:column;align-items:flex-start;", "{align-self:flex-end;}}"], transition("box-shadow"), space(1.5), space(2), getBorderRadius(theme, "large"), getColor(theme, backgroundColor), getBoxShadow(theme, "tiny"), getBoxShadow(theme, "small"), Arrow, space(1), breakpoint(descriptionBreakpoint), Arrow);
});
var ImageWrapper = styled.div.withConfig({
  componentId: "sc-ivd45s-3"
})(function (_ref3) {
  var theme = _ref3.theme;
  return css(["display:flex;flex-shrink:0;align-items:center;justify-content:center;width:", ";height:", ";margin-right:", ";border-radius:", ";background-color:", ";", "{display:none;}"], space(iconWrapperSizeSpace), space(iconWrapperSizeSpace), space(2), getBorderRadius(theme, "huge"), getColor(theme, imageWrapperBackgroundColor), breakpoint("small", "large"));
});
var Title = styled(Link).withConfig({
  componentId: "sc-ivd45s-4"
})(["", ";text-decoration:none;&::before{", ";content:\"\";z-index:1;}", "{margin-bottom:", ";}"], cssTextAtm({
  typography: "big3",
  onColor: backgroundColor
}), cover(), breakpoint(descriptionBreakpoint), space(1));
var Text = styled.p.withConfig({
  componentId: "sc-ivd45s-5"
})(["", ";flex-grow:1;", "{display:none;}"], cssTextAtm({
  typography: "small1",
  onColor: backgroundColor,
  pushSpace: 2.5
}), breakpoint("small", descriptionBreakpoint));
function DescriptionItemLinkMol(_ref4) {
  var icon = _ref4.icon,
    image = _ref4.image,
    title = _ref4.title,
    text = _ref4.text,
    link = _ref4.link,
    restProps = _objectWithoutProperties(_ref4, _excluded);
  var imageJsx = image && /*#__PURE__*/React.createElement(ImageWrapper, null, /*#__PURE__*/React.createElement(Picture, {
    srcData: image
  }));
  if (icon) {
    imageJsx = /*#__PURE__*/React.createElement(ImageWrapper, null, /*#__PURE__*/React.createElement(OnColorContext.Provider, {
      value: imageWrapperBackgroundColor
    }, /*#__PURE__*/React.createElement(IconAtm, {
      icon: icon,
      sizeSpace: 2
    })));
  }
  return /*#__PURE__*/React.createElement(Container, restProps, imageJsx, /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Title, link, title), /*#__PURE__*/React.createElement(Text, null, text), /*#__PURE__*/React.createElement(Arrow, null)));
}
export default DescriptionItemLinkMol;